import { Component, OnInit, ViewChild, Input, ɵConsole } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { LaudoInput } from 'src/app/models/laudo-input';
import { FormImgAdicionalLaudoComponent } from '../form-img-adicional-laudo/form-img-adicional-laudo.component';
import { LaudoUnionService } from 'src/app/services/http/laudo-union.service';
import { ActivatedRoute } from '@angular/router';
import { Utils } from 'src/app/utils/utils';
import { ModalLoadingService } from 'src/app/services/modal-loading.service';
import { ModalMsgService } from 'src/app/services/modal-msg.service';

@Component({
  selector: 'app-form-img-laudo',
  templateUrl: './form-img-laudo.component.html',
  styleUrls: ['./form-img-laudo.component.scss']
})
export class FormImgLaudoComponent implements OnInit {

  @ViewChild(FormImgAdicionalLaudoComponent, { static: true }) formImgAdicional: FormImgAdicionalLaudoComponent;

  @Input() formId: string;
  @Input() elements = {};
  @Input() template: any[] = [];
  token;
  modalElements: any = {};
  constructor(private msg: ModalMsgService, private loading: ModalLoadingService, private laudoService: LaudoUnionService, private activatedRoute: ActivatedRoute) { }


  ngOnInit() {
    this.token = this.activatedRoute.snapshot.params.id;
  }

  ngOnChanges() {
    this.modalElements = {};
    for (const key in this.elements) {
      const e = this.elements[key];
      if(e.type == 'MEDIA') {
        this.modalElements[e.name] = e;
      }
    }
  }

  async getMultiplasFotos(fotos: { from: LaudoInput, image: string }[]) {
    let erros = 0;
    for (let i = 0; i < fotos.length; i++) {

      const f = fotos[i];
      this.loading.open('Transferindo ' + (i+1) + ' de ' + fotos.length + ' arquivos');
      if (f.from.name == 'FOTO_ADICIONAL') {
        await this.formImgAdicional.addFotoAdicional(null, f?.from?.value, f.image);
      }
      else {
        try {
          f.from.loading = true;
          let imageBlob = await Utils.base64ToBlob(f.image);
          let response = await this.laudoService.updateInput(f.from.name, '', this.token, imageBlob);
          f.from.control.patchValue(response.value);
        }
        catch (error) {
          erros++;
        } finally {
          f.from.loading = false;
        }
      }
      this.loading.close();
    }


    if(erros>0) {
      this.msg.open('', 'Ocorreram ' + erros + ' erros ao transferir um total de ' + fotos.length +' arquivos', 'danger');
    }
  }

}
